import * as i0 from '@angular/core';
import { Component, SkipSelf, Host, Input, NgModule, Inject, ContentChildren, Output } from '@angular/core';
import * as i1 from 'devextreme-angular/core';
import { NestedOption, NestedOptionHost, DxIntegrationModule, CollectionNestedOption, extractTemplate, DxTemplateHost } from 'devextreme-angular/core';
import { DOCUMENT } from '@angular/common';
import { PROPERTY_TOKEN_items, PROPERTY_TOKEN_resources, PROPERTY_TOKEN_views } from 'devextreme-angular/core/tokens';

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
const _c0 = ["*"];
let DxoSchedulerAppointmentDraggingComponent = /*#__PURE__*/(() => {
  class DxoSchedulerAppointmentDraggingComponent extends NestedOption {
    get autoScroll() {
      return this._getOption('autoScroll');
    }
    set autoScroll(value) {
      this._setOption('autoScroll', value);
    }
    get data() {
      return this._getOption('data');
    }
    set data(value) {
      this._setOption('data', value);
    }
    get group() {
      return this._getOption('group');
    }
    set group(value) {
      this._setOption('group', value);
    }
    get onAdd() {
      return this._getOption('onAdd');
    }
    set onAdd(value) {
      this._setOption('onAdd', value);
    }
    get onDragEnd() {
      return this._getOption('onDragEnd');
    }
    set onDragEnd(value) {
      this._setOption('onDragEnd', value);
    }
    get onDragMove() {
      return this._getOption('onDragMove');
    }
    set onDragMove(value) {
      this._setOption('onDragMove', value);
    }
    get onDragStart() {
      return this._getOption('onDragStart');
    }
    set onDragStart(value) {
      this._setOption('onDragStart', value);
    }
    get onRemove() {
      return this._getOption('onRemove');
    }
    set onRemove(value) {
      this._setOption('onRemove', value);
    }
    get scrollSensitivity() {
      return this._getOption('scrollSensitivity');
    }
    set scrollSensitivity(value) {
      this._setOption('scrollSensitivity', value);
    }
    get scrollSpeed() {
      return this._getOption('scrollSpeed');
    }
    set scrollSpeed(value) {
      this._setOption('scrollSpeed', value);
    }
    get _optionPath() {
      return 'appointmentDragging';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoSchedulerAppointmentDraggingComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoSchedulerAppointmentDraggingComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoSchedulerAppointmentDraggingComponent,
      selectors: [["dxo-scheduler-appointment-dragging"]],
      inputs: {
        autoScroll: "autoScroll",
        data: "data",
        group: "group",
        onAdd: "onAdd",
        onDragEnd: "onDragEnd",
        onDragMove: "onDragMove",
        onDragStart: "onDragStart",
        onRemove: "onRemove",
        scrollSensitivity: "scrollSensitivity",
        scrollSpeed: "scrollSpeed"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoSchedulerAppointmentDraggingComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoSchedulerAppointmentDraggingComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoSchedulerAppointmentDraggingModule = /*#__PURE__*/(() => {
  class DxoSchedulerAppointmentDraggingModule {
    /** @nocollapse */static ɵfac = function DxoSchedulerAppointmentDraggingModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoSchedulerAppointmentDraggingModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoSchedulerAppointmentDraggingModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoSchedulerAppointmentDraggingComponent]
    });
  }
  return DxoSchedulerAppointmentDraggingModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoSchedulerEditingComponent = /*#__PURE__*/(() => {
  class DxoSchedulerEditingComponent extends NestedOption {
    get allowAdding() {
      return this._getOption('allowAdding');
    }
    set allowAdding(value) {
      this._setOption('allowAdding', value);
    }
    get allowDeleting() {
      return this._getOption('allowDeleting');
    }
    set allowDeleting(value) {
      this._setOption('allowDeleting', value);
    }
    get allowDragging() {
      return this._getOption('allowDragging');
    }
    set allowDragging(value) {
      this._setOption('allowDragging', value);
    }
    get allowResizing() {
      return this._getOption('allowResizing');
    }
    set allowResizing(value) {
      this._setOption('allowResizing', value);
    }
    get allowTimeZoneEditing() {
      return this._getOption('allowTimeZoneEditing');
    }
    set allowTimeZoneEditing(value) {
      this._setOption('allowTimeZoneEditing', value);
    }
    get allowUpdating() {
      return this._getOption('allowUpdating');
    }
    set allowUpdating(value) {
      this._setOption('allowUpdating', value);
    }
    get _optionPath() {
      return 'editing';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoSchedulerEditingComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoSchedulerEditingComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoSchedulerEditingComponent,
      selectors: [["dxo-scheduler-editing"]],
      inputs: {
        allowAdding: "allowAdding",
        allowDeleting: "allowDeleting",
        allowDragging: "allowDragging",
        allowResizing: "allowResizing",
        allowTimeZoneEditing: "allowTimeZoneEditing",
        allowUpdating: "allowUpdating"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoSchedulerEditingComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoSchedulerEditingComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoSchedulerEditingModule = /*#__PURE__*/(() => {
  class DxoSchedulerEditingModule {
    /** @nocollapse */static ɵfac = function DxoSchedulerEditingModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoSchedulerEditingModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoSchedulerEditingModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoSchedulerEditingComponent]
    });
  }
  return DxoSchedulerEditingModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxiSchedulerItemComponent = /*#__PURE__*/(() => {
  class DxiSchedulerItemComponent extends CollectionNestedOption {
    renderer;
    document;
    element;
    get cssClass() {
      return this._getOption('cssClass');
    }
    set cssClass(value) {
      this._setOption('cssClass', value);
    }
    get disabled() {
      return this._getOption('disabled');
    }
    set disabled(value) {
      this._setOption('disabled', value);
    }
    get html() {
      return this._getOption('html');
    }
    set html(value) {
      this._setOption('html', value);
    }
    get locateInMenu() {
      return this._getOption('locateInMenu');
    }
    set locateInMenu(value) {
      this._setOption('locateInMenu', value);
    }
    get location() {
      return this._getOption('location');
    }
    set location(value) {
      this._setOption('location', value);
    }
    get menuItemTemplate() {
      return this._getOption('menuItemTemplate');
    }
    set menuItemTemplate(value) {
      this._setOption('menuItemTemplate', value);
    }
    get name() {
      return this._getOption('name');
    }
    set name(value) {
      this._setOption('name', value);
    }
    get options() {
      return this._getOption('options');
    }
    set options(value) {
      this._setOption('options', value);
    }
    get showText() {
      return this._getOption('showText');
    }
    set showText(value) {
      this._setOption('showText', value);
    }
    get template() {
      return this._getOption('template');
    }
    set template(value) {
      this._setOption('template', value);
    }
    get text() {
      return this._getOption('text');
    }
    set text(value) {
      this._setOption('text', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get widget() {
      return this._getOption('widget');
    }
    set widget(value) {
      this._setOption('widget', value);
    }
    get elementAttr() {
      return this._getOption('elementAttr');
    }
    set elementAttr(value) {
      this._setOption('elementAttr', value);
    }
    get hint() {
      return this._getOption('hint');
    }
    set hint(value) {
      this._setOption('hint', value);
    }
    get icon() {
      return this._getOption('icon');
    }
    set icon(value) {
      this._setOption('icon', value);
    }
    get type() {
      return this._getOption('type');
    }
    set type(value) {
      this._setOption('type', value);
    }
    get _optionPath() {
      return 'items';
    }
    constructor(parentOptionHost, optionHost, renderer, document, templateHost, element) {
      super();
      this.renderer = renderer;
      this.document = document;
      this.element = element;
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
      templateHost.setHost(this);
    }
    setTemplate(template) {
      this.template = template;
    }
    ngAfterViewInit() {
      extractTemplate(this, this.element, this.renderer, this.document);
    }
    ngOnDestroy() {
      this._deleteRemovedOptions(this._fullOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxiSchedulerItemComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiSchedulerItemComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(DOCUMENT), i0.ɵɵdirectiveInject(i1.DxTemplateHost, 1), i0.ɵɵdirectiveInject(i0.ElementRef));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxiSchedulerItemComponent,
      selectors: [["dxi-scheduler-item"]],
      inputs: {
        cssClass: "cssClass",
        disabled: "disabled",
        html: "html",
        locateInMenu: "locateInMenu",
        location: "location",
        menuItemTemplate: "menuItemTemplate",
        name: "name",
        options: "options",
        showText: "showText",
        template: "template",
        text: "text",
        visible: "visible",
        widget: "widget",
        elementAttr: "elementAttr",
        hint: "hint",
        icon: "icon",
        type: "type"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost, DxTemplateHost, {
        provide: PROPERTY_TOKEN_items,
        useExisting: DxiSchedulerItemComponent
      }]), i0.ɵɵInheritDefinitionFeature],
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function DxiSchedulerItemComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      dependencies: [DxIntegrationModule],
      styles: ["[_nghost-%COMP%]{display:block}"]
    });
  }
  return DxiSchedulerItemComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxiSchedulerItemModule = /*#__PURE__*/(() => {
  class DxiSchedulerItemModule {
    /** @nocollapse */static ɵfac = function DxiSchedulerItemModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiSchedulerItemModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxiSchedulerItemModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxiSchedulerItemComponent]
    });
  }
  return DxiSchedulerItemModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxiSchedulerOptionsItemComponent = /*#__PURE__*/(() => {
  class DxiSchedulerOptionsItemComponent extends CollectionNestedOption {
    renderer;
    document;
    element;
    get disabled() {
      return this._getOption('disabled');
    }
    set disabled(value) {
      this._setOption('disabled', value);
    }
    get elementAttr() {
      return this._getOption('elementAttr');
    }
    set elementAttr(value) {
      this._setOption('elementAttr', value);
    }
    get hint() {
      return this._getOption('hint');
    }
    set hint(value) {
      this._setOption('hint', value);
    }
    get icon() {
      return this._getOption('icon');
    }
    set icon(value) {
      this._setOption('icon', value);
    }
    get template() {
      return this._getOption('template');
    }
    set template(value) {
      this._setOption('template', value);
    }
    get text() {
      return this._getOption('text');
    }
    set text(value) {
      this._setOption('text', value);
    }
    get type() {
      return this._getOption('type');
    }
    set type(value) {
      this._setOption('type', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get _optionPath() {
      return 'items';
    }
    constructor(parentOptionHost, optionHost, renderer, document, templateHost, element) {
      super();
      this.renderer = renderer;
      this.document = document;
      this.element = element;
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
      templateHost.setHost(this);
    }
    setTemplate(template) {
      this.template = template;
    }
    ngAfterViewInit() {
      extractTemplate(this, this.element, this.renderer, this.document);
    }
    ngOnDestroy() {
      this._deleteRemovedOptions(this._fullOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxiSchedulerOptionsItemComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiSchedulerOptionsItemComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(DOCUMENT), i0.ɵɵdirectiveInject(i1.DxTemplateHost, 1), i0.ɵɵdirectiveInject(i0.ElementRef));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxiSchedulerOptionsItemComponent,
      selectors: [["dxi-scheduler-options-item"]],
      inputs: {
        disabled: "disabled",
        elementAttr: "elementAttr",
        hint: "hint",
        icon: "icon",
        template: "template",
        text: "text",
        type: "type",
        visible: "visible"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost, DxTemplateHost, {
        provide: PROPERTY_TOKEN_items,
        useExisting: DxiSchedulerOptionsItemComponent
      }]), i0.ɵɵInheritDefinitionFeature],
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function DxiSchedulerOptionsItemComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      dependencies: [DxIntegrationModule],
      styles: ["[_nghost-%COMP%]{display:block}"]
    });
  }
  return DxiSchedulerOptionsItemComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxiSchedulerOptionsItemModule = /*#__PURE__*/(() => {
  class DxiSchedulerOptionsItemModule {
    /** @nocollapse */static ɵfac = function DxiSchedulerOptionsItemModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiSchedulerOptionsItemModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxiSchedulerOptionsItemModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxiSchedulerOptionsItemComponent]
    });
  }
  return DxiSchedulerOptionsItemModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoSchedulerOptionsComponent = /*#__PURE__*/(() => {
  class DxoSchedulerOptionsComponent extends NestedOption {
    set _itemsContentChildren(value) {
      this.setChildren('items', value);
    }
    get accessKey() {
      return this._getOption('accessKey');
    }
    set accessKey(value) {
      this._setOption('accessKey', value);
    }
    get activeStateEnabled() {
      return this._getOption('activeStateEnabled');
    }
    set activeStateEnabled(value) {
      this._setOption('activeStateEnabled', value);
    }
    get buttonTemplate() {
      return this._getOption('buttonTemplate');
    }
    set buttonTemplate(value) {
      this._setOption('buttonTemplate', value);
    }
    get disabled() {
      return this._getOption('disabled');
    }
    set disabled(value) {
      this._setOption('disabled', value);
    }
    get elementAttr() {
      return this._getOption('elementAttr');
    }
    set elementAttr(value) {
      this._setOption('elementAttr', value);
    }
    get focusStateEnabled() {
      return this._getOption('focusStateEnabled');
    }
    set focusStateEnabled(value) {
      this._setOption('focusStateEnabled', value);
    }
    get height() {
      return this._getOption('height');
    }
    set height(value) {
      this._setOption('height', value);
    }
    get hint() {
      return this._getOption('hint');
    }
    set hint(value) {
      this._setOption('hint', value);
    }
    get hoverStateEnabled() {
      return this._getOption('hoverStateEnabled');
    }
    set hoverStateEnabled(value) {
      this._setOption('hoverStateEnabled', value);
    }
    get items() {
      return this._getOption('items');
    }
    set items(value) {
      this._setOption('items', value);
    }
    get keyExpr() {
      return this._getOption('keyExpr');
    }
    set keyExpr(value) {
      this._setOption('keyExpr', value);
    }
    get onContentReady() {
      return this._getOption('onContentReady');
    }
    set onContentReady(value) {
      this._setOption('onContentReady', value);
    }
    get onDisposing() {
      return this._getOption('onDisposing');
    }
    set onDisposing(value) {
      this._setOption('onDisposing', value);
    }
    get onInitialized() {
      return this._getOption('onInitialized');
    }
    set onInitialized(value) {
      this._setOption('onInitialized', value);
    }
    get onItemClick() {
      return this._getOption('onItemClick');
    }
    set onItemClick(value) {
      this._setOption('onItemClick', value);
    }
    get onOptionChanged() {
      return this._getOption('onOptionChanged');
    }
    set onOptionChanged(value) {
      this._setOption('onOptionChanged', value);
    }
    get onSelectionChanged() {
      return this._getOption('onSelectionChanged');
    }
    set onSelectionChanged(value) {
      this._setOption('onSelectionChanged', value);
    }
    get rtlEnabled() {
      return this._getOption('rtlEnabled');
    }
    set rtlEnabled(value) {
      this._setOption('rtlEnabled', value);
    }
    get selectedItemKeys() {
      return this._getOption('selectedItemKeys');
    }
    set selectedItemKeys(value) {
      this._setOption('selectedItemKeys', value);
    }
    get selectedItems() {
      return this._getOption('selectedItems');
    }
    set selectedItems(value) {
      this._setOption('selectedItems', value);
    }
    get selectionMode() {
      return this._getOption('selectionMode');
    }
    set selectionMode(value) {
      this._setOption('selectionMode', value);
    }
    get stylingMode() {
      return this._getOption('stylingMode');
    }
    set stylingMode(value) {
      this._setOption('stylingMode', value);
    }
    get tabIndex() {
      return this._getOption('tabIndex');
    }
    set tabIndex(value) {
      this._setOption('tabIndex', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    selectedItemKeysChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    selectedItemsChange;
    get _optionPath() {
      return 'options';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      this._createEventEmitters([{
        emit: 'selectedItemKeysChange'
      }, {
        emit: 'selectedItemsChange'
      }]);
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoSchedulerOptionsComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoSchedulerOptionsComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoSchedulerOptionsComponent,
      selectors: [["dxo-scheduler-options"]],
      contentQueries: function DxoSchedulerOptionsComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, PROPERTY_TOKEN_items, 4);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._itemsContentChildren = _t);
        }
      },
      inputs: {
        accessKey: "accessKey",
        activeStateEnabled: "activeStateEnabled",
        buttonTemplate: "buttonTemplate",
        disabled: "disabled",
        elementAttr: "elementAttr",
        focusStateEnabled: "focusStateEnabled",
        height: "height",
        hint: "hint",
        hoverStateEnabled: "hoverStateEnabled",
        items: "items",
        keyExpr: "keyExpr",
        onContentReady: "onContentReady",
        onDisposing: "onDisposing",
        onInitialized: "onInitialized",
        onItemClick: "onItemClick",
        onOptionChanged: "onOptionChanged",
        onSelectionChanged: "onSelectionChanged",
        rtlEnabled: "rtlEnabled",
        selectedItemKeys: "selectedItemKeys",
        selectedItems: "selectedItems",
        selectionMode: "selectionMode",
        stylingMode: "stylingMode",
        tabIndex: "tabIndex",
        visible: "visible",
        width: "width"
      },
      outputs: {
        selectedItemKeysChange: "selectedItemKeysChange",
        selectedItemsChange: "selectedItemsChange"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoSchedulerOptionsComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoSchedulerOptionsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoSchedulerOptionsModule = /*#__PURE__*/(() => {
  class DxoSchedulerOptionsModule {
    /** @nocollapse */static ɵfac = function DxoSchedulerOptionsModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoSchedulerOptionsModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoSchedulerOptionsModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoSchedulerOptionsComponent]
    });
  }
  return DxoSchedulerOptionsModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxiSchedulerResourceComponent = /*#__PURE__*/(() => {
  class DxiSchedulerResourceComponent extends CollectionNestedOption {
    get allowMultiple() {
      return this._getOption('allowMultiple');
    }
    set allowMultiple(value) {
      this._setOption('allowMultiple', value);
    }
    get colorExpr() {
      return this._getOption('colorExpr');
    }
    set colorExpr(value) {
      this._setOption('colorExpr', value);
    }
    get dataSource() {
      return this._getOption('dataSource');
    }
    set dataSource(value) {
      this._setOption('dataSource', value);
    }
    get displayExpr() {
      return this._getOption('displayExpr');
    }
    set displayExpr(value) {
      this._setOption('displayExpr', value);
    }
    get fieldExpr() {
      return this._getOption('fieldExpr');
    }
    set fieldExpr(value) {
      this._setOption('fieldExpr', value);
    }
    get label() {
      return this._getOption('label');
    }
    set label(value) {
      this._setOption('label', value);
    }
    get useColorAsDefault() {
      return this._getOption('useColorAsDefault');
    }
    set useColorAsDefault(value) {
      this._setOption('useColorAsDefault', value);
    }
    get valueExpr() {
      return this._getOption('valueExpr');
    }
    set valueExpr(value) {
      this._setOption('valueExpr', value);
    }
    get _optionPath() {
      return 'resources';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnDestroy() {
      this._deleteRemovedOptions(this._fullOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxiSchedulerResourceComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiSchedulerResourceComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxiSchedulerResourceComponent,
      selectors: [["dxi-scheduler-resource"]],
      inputs: {
        allowMultiple: "allowMultiple",
        colorExpr: "colorExpr",
        dataSource: "dataSource",
        displayExpr: "displayExpr",
        fieldExpr: "fieldExpr",
        label: "label",
        useColorAsDefault: "useColorAsDefault",
        valueExpr: "valueExpr"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost, {
        provide: PROPERTY_TOKEN_resources,
        useExisting: DxiSchedulerResourceComponent
      }]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxiSchedulerResourceComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxiSchedulerResourceComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxiSchedulerResourceModule = /*#__PURE__*/(() => {
  class DxiSchedulerResourceModule {
    /** @nocollapse */static ɵfac = function DxiSchedulerResourceModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiSchedulerResourceModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxiSchedulerResourceModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxiSchedulerResourceComponent]
    });
  }
  return DxiSchedulerResourceModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoSchedulerScrollingComponent = /*#__PURE__*/(() => {
  class DxoSchedulerScrollingComponent extends NestedOption {
    get mode() {
      return this._getOption('mode');
    }
    set mode(value) {
      this._setOption('mode', value);
    }
    get _optionPath() {
      return 'scrolling';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoSchedulerScrollingComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoSchedulerScrollingComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoSchedulerScrollingComponent,
      selectors: [["dxo-scheduler-scrolling"]],
      inputs: {
        mode: "mode"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoSchedulerScrollingComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoSchedulerScrollingComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoSchedulerScrollingModule = /*#__PURE__*/(() => {
  class DxoSchedulerScrollingModule {
    /** @nocollapse */static ɵfac = function DxoSchedulerScrollingModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoSchedulerScrollingModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoSchedulerScrollingModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoSchedulerScrollingComponent]
    });
  }
  return DxoSchedulerScrollingModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxiSchedulerToolbarItemComponent = /*#__PURE__*/(() => {
  class DxiSchedulerToolbarItemComponent extends CollectionNestedOption {
    renderer;
    document;
    element;
    get cssClass() {
      return this._getOption('cssClass');
    }
    set cssClass(value) {
      this._setOption('cssClass', value);
    }
    get disabled() {
      return this._getOption('disabled');
    }
    set disabled(value) {
      this._setOption('disabled', value);
    }
    get html() {
      return this._getOption('html');
    }
    set html(value) {
      this._setOption('html', value);
    }
    get locateInMenu() {
      return this._getOption('locateInMenu');
    }
    set locateInMenu(value) {
      this._setOption('locateInMenu', value);
    }
    get location() {
      return this._getOption('location');
    }
    set location(value) {
      this._setOption('location', value);
    }
    get menuItemTemplate() {
      return this._getOption('menuItemTemplate');
    }
    set menuItemTemplate(value) {
      this._setOption('menuItemTemplate', value);
    }
    get name() {
      return this._getOption('name');
    }
    set name(value) {
      this._setOption('name', value);
    }
    get options() {
      return this._getOption('options');
    }
    set options(value) {
      this._setOption('options', value);
    }
    get showText() {
      return this._getOption('showText');
    }
    set showText(value) {
      this._setOption('showText', value);
    }
    get template() {
      return this._getOption('template');
    }
    set template(value) {
      this._setOption('template', value);
    }
    get text() {
      return this._getOption('text');
    }
    set text(value) {
      this._setOption('text', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get widget() {
      return this._getOption('widget');
    }
    set widget(value) {
      this._setOption('widget', value);
    }
    get _optionPath() {
      return 'items';
    }
    constructor(parentOptionHost, optionHost, renderer, document, templateHost, element) {
      super();
      this.renderer = renderer;
      this.document = document;
      this.element = element;
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
      templateHost.setHost(this);
    }
    setTemplate(template) {
      this.template = template;
    }
    ngAfterViewInit() {
      extractTemplate(this, this.element, this.renderer, this.document);
    }
    ngOnDestroy() {
      this._deleteRemovedOptions(this._fullOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxiSchedulerToolbarItemComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiSchedulerToolbarItemComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(DOCUMENT), i0.ɵɵdirectiveInject(i1.DxTemplateHost, 1), i0.ɵɵdirectiveInject(i0.ElementRef));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxiSchedulerToolbarItemComponent,
      selectors: [["dxi-scheduler-toolbar-item"]],
      inputs: {
        cssClass: "cssClass",
        disabled: "disabled",
        html: "html",
        locateInMenu: "locateInMenu",
        location: "location",
        menuItemTemplate: "menuItemTemplate",
        name: "name",
        options: "options",
        showText: "showText",
        template: "template",
        text: "text",
        visible: "visible",
        widget: "widget"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost, DxTemplateHost, {
        provide: PROPERTY_TOKEN_items,
        useExisting: DxiSchedulerToolbarItemComponent
      }]), i0.ɵɵInheritDefinitionFeature],
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function DxiSchedulerToolbarItemComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      dependencies: [DxIntegrationModule],
      styles: ["[_nghost-%COMP%]{display:block}"]
    });
  }
  return DxiSchedulerToolbarItemComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxiSchedulerToolbarItemModule = /*#__PURE__*/(() => {
  class DxiSchedulerToolbarItemModule {
    /** @nocollapse */static ɵfac = function DxiSchedulerToolbarItemModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiSchedulerToolbarItemModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxiSchedulerToolbarItemModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxiSchedulerToolbarItemComponent]
    });
  }
  return DxiSchedulerToolbarItemModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoSchedulerToolbarComponent = /*#__PURE__*/(() => {
  class DxoSchedulerToolbarComponent extends NestedOption {
    set _itemsContentChildren(value) {
      this.setChildren('items', value);
    }
    get disabled() {
      return this._getOption('disabled');
    }
    set disabled(value) {
      this._setOption('disabled', value);
    }
    get items() {
      return this._getOption('items');
    }
    set items(value) {
      this._setOption('items', value);
    }
    get multiline() {
      return this._getOption('multiline');
    }
    set multiline(value) {
      this._setOption('multiline', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get _optionPath() {
      return 'toolbar';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoSchedulerToolbarComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoSchedulerToolbarComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoSchedulerToolbarComponent,
      selectors: [["dxo-scheduler-toolbar"]],
      contentQueries: function DxoSchedulerToolbarComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, PROPERTY_TOKEN_items, 4);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._itemsContentChildren = _t);
        }
      },
      inputs: {
        disabled: "disabled",
        items: "items",
        multiline: "multiline",
        visible: "visible"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoSchedulerToolbarComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoSchedulerToolbarComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoSchedulerToolbarModule = /*#__PURE__*/(() => {
  class DxoSchedulerToolbarModule {
    /** @nocollapse */static ɵfac = function DxoSchedulerToolbarModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoSchedulerToolbarModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoSchedulerToolbarModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoSchedulerToolbarComponent]
    });
  }
  return DxoSchedulerToolbarModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxiSchedulerViewComponent = /*#__PURE__*/(() => {
  class DxiSchedulerViewComponent extends CollectionNestedOption {
    get agendaDuration() {
      return this._getOption('agendaDuration');
    }
    set agendaDuration(value) {
      this._setOption('agendaDuration', value);
    }
    get allDayPanelMode() {
      return this._getOption('allDayPanelMode');
    }
    set allDayPanelMode(value) {
      this._setOption('allDayPanelMode', value);
    }
    get appointmentCollectorTemplate() {
      return this._getOption('appointmentCollectorTemplate');
    }
    set appointmentCollectorTemplate(value) {
      this._setOption('appointmentCollectorTemplate', value);
    }
    get appointmentTemplate() {
      return this._getOption('appointmentTemplate');
    }
    set appointmentTemplate(value) {
      this._setOption('appointmentTemplate', value);
    }
    get appointmentTooltipTemplate() {
      return this._getOption('appointmentTooltipTemplate');
    }
    set appointmentTooltipTemplate(value) {
      this._setOption('appointmentTooltipTemplate', value);
    }
    get cellDuration() {
      return this._getOption('cellDuration');
    }
    set cellDuration(value) {
      this._setOption('cellDuration', value);
    }
    get dataCellTemplate() {
      return this._getOption('dataCellTemplate');
    }
    set dataCellTemplate(value) {
      this._setOption('dataCellTemplate', value);
    }
    get dateCellTemplate() {
      return this._getOption('dateCellTemplate');
    }
    set dateCellTemplate(value) {
      this._setOption('dateCellTemplate', value);
    }
    get dropDownAppointmentTemplate() {
      return this._getOption('dropDownAppointmentTemplate');
    }
    set dropDownAppointmentTemplate(value) {
      this._setOption('dropDownAppointmentTemplate', value);
    }
    get endDayHour() {
      return this._getOption('endDayHour');
    }
    set endDayHour(value) {
      this._setOption('endDayHour', value);
    }
    get firstDayOfWeek() {
      return this._getOption('firstDayOfWeek');
    }
    set firstDayOfWeek(value) {
      this._setOption('firstDayOfWeek', value);
    }
    get groupByDate() {
      return this._getOption('groupByDate');
    }
    set groupByDate(value) {
      this._setOption('groupByDate', value);
    }
    get groupOrientation() {
      return this._getOption('groupOrientation');
    }
    set groupOrientation(value) {
      this._setOption('groupOrientation', value);
    }
    get groups() {
      return this._getOption('groups');
    }
    set groups(value) {
      this._setOption('groups', value);
    }
    get intervalCount() {
      return this._getOption('intervalCount');
    }
    set intervalCount(value) {
      this._setOption('intervalCount', value);
    }
    get maxAppointmentsPerCell() {
      return this._getOption('maxAppointmentsPerCell');
    }
    set maxAppointmentsPerCell(value) {
      this._setOption('maxAppointmentsPerCell', value);
    }
    get name() {
      return this._getOption('name');
    }
    set name(value) {
      this._setOption('name', value);
    }
    get offset() {
      return this._getOption('offset');
    }
    set offset(value) {
      this._setOption('offset', value);
    }
    get resourceCellTemplate() {
      return this._getOption('resourceCellTemplate');
    }
    set resourceCellTemplate(value) {
      this._setOption('resourceCellTemplate', value);
    }
    get scrolling() {
      return this._getOption('scrolling');
    }
    set scrolling(value) {
      this._setOption('scrolling', value);
    }
    get startDate() {
      return this._getOption('startDate');
    }
    set startDate(value) {
      this._setOption('startDate', value);
    }
    get startDayHour() {
      return this._getOption('startDayHour');
    }
    set startDayHour(value) {
      this._setOption('startDayHour', value);
    }
    get timeCellTemplate() {
      return this._getOption('timeCellTemplate');
    }
    set timeCellTemplate(value) {
      this._setOption('timeCellTemplate', value);
    }
    get type() {
      return this._getOption('type');
    }
    set type(value) {
      this._setOption('type', value);
    }
    get _optionPath() {
      return 'views';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnDestroy() {
      this._deleteRemovedOptions(this._fullOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxiSchedulerViewComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiSchedulerViewComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxiSchedulerViewComponent,
      selectors: [["dxi-scheduler-view"]],
      inputs: {
        agendaDuration: "agendaDuration",
        allDayPanelMode: "allDayPanelMode",
        appointmentCollectorTemplate: "appointmentCollectorTemplate",
        appointmentTemplate: "appointmentTemplate",
        appointmentTooltipTemplate: "appointmentTooltipTemplate",
        cellDuration: "cellDuration",
        dataCellTemplate: "dataCellTemplate",
        dateCellTemplate: "dateCellTemplate",
        dropDownAppointmentTemplate: "dropDownAppointmentTemplate",
        endDayHour: "endDayHour",
        firstDayOfWeek: "firstDayOfWeek",
        groupByDate: "groupByDate",
        groupOrientation: "groupOrientation",
        groups: "groups",
        intervalCount: "intervalCount",
        maxAppointmentsPerCell: "maxAppointmentsPerCell",
        name: "name",
        offset: "offset",
        resourceCellTemplate: "resourceCellTemplate",
        scrolling: "scrolling",
        startDate: "startDate",
        startDayHour: "startDayHour",
        timeCellTemplate: "timeCellTemplate",
        type: "type"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost, {
        provide: PROPERTY_TOKEN_views,
        useExisting: DxiSchedulerViewComponent
      }]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxiSchedulerViewComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxiSchedulerViewComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxiSchedulerViewModule = /*#__PURE__*/(() => {
  class DxiSchedulerViewModule {
    /** @nocollapse */static ɵfac = function DxiSchedulerViewModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiSchedulerViewModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxiSchedulerViewModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxiSchedulerViewComponent]
    });
  }
  return DxiSchedulerViewModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */

/**
 * Generated bundle index. Do not edit.
 */

export { DxiSchedulerItemComponent, DxiSchedulerItemModule, DxiSchedulerOptionsItemComponent, DxiSchedulerOptionsItemModule, DxiSchedulerResourceComponent, DxiSchedulerResourceModule, DxiSchedulerToolbarItemComponent, DxiSchedulerToolbarItemModule, DxiSchedulerViewComponent, DxiSchedulerViewModule, DxoSchedulerAppointmentDraggingComponent, DxoSchedulerAppointmentDraggingModule, DxoSchedulerEditingComponent, DxoSchedulerEditingModule, DxoSchedulerOptionsComponent, DxoSchedulerOptionsModule, DxoSchedulerScrollingComponent, DxoSchedulerScrollingModule, DxoSchedulerToolbarComponent, DxoSchedulerToolbarModule };
